import { styled } from 'stitches.config'

export const DogBiologyRoot = styled('section', {
  width: '100%',
  background: '$tertiary-200',
  padding: '$4 $4 $7',
  '@bp2': {
    padding: '$10 $4',
  }
})

export const Header = styled('h2', {
  fontSize: '$h2',
  textAlign: 'center',
  margin: 'auto',
  marginBottom: '$4',
  width: '100%',
  maxWidth: '400px',
  '@bp2': {
    maxWidth: 'none',
    marginBottom: '$6',
    fontSize: '$h1',
  }
})

export const Feature = styled('div', {
  padding: '$3',
  borderTop: '1px solid $accent-black',
  width: '100%',
  textAlign: 'center',

  '@bp2': {
    '&:first-child': {
      borderTop: '2px solid $accent-black',
    },
    
    '&:last-child': {
      borderBottom: '2px solid $accent-black',
    },
  }
})

const flex = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}

export const FeatureColumn = styled('div', {
  ...flex,
  flexDirection: 'column',
  width: '100%',
  maxWidth: '436px',

})

export const FeatureBox = styled('div', {
  ...flex,
  flexDirection: 'column',
  width: '100%',

  '& > div:last-child > div:last-child': {
    borderBottom: '2px solid $accent-black'
  },

  '& > div:first-child > div:first-child': {
    borderTop: '2px solid $accent-black'
  },

  '@bp2': {
    flexDirection: 'row',
    gap: '$5',
  },
  '@bp3': {
    gap: '$10',
  }
})